import React, { useEffect, useMemo, useState } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Benefits from './components/Benefits'
import HowItWorks from './components/HowItWorks'
import EventTypes from './components/EventTypes'
import Testimonials from './components/Testimonials'
import FAQ from './components/FAQ'
import ContactSection from './components/ContactSection'
import Footer from './components/Footer'
import CookieBanner from './components/CookieBanner'
import ThankYou from './components/ThankYou'

const App = () => {
  const [hash, setHash] = useState(window.location.hash)

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash)
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  const isThankYou = useMemo(() => hash === '#thank-you', [hash])

  return (
    <div className="bg-brand-bg text-brand-text font-sans antialiased">
      <Header />
      <main>
        {isThankYou ? (
          <ThankYou />
        ) : (
          <>
            <Hero />
            <Benefits />
            <HowItWorks />
            <EventTypes />
            <Testimonials />
            <FAQ />
            <ContactSection />
          </>
        )}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  )
}

export default App